import _objectSpread from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import VueAdsPagination, { VueAdsPageButton } from "vue-ads-pagination";
import "../../../node_modules/@fortawesome/fontawesome-free/css/all.css";
import "../../../node_modules/vue-ads-pagination/dist/vue-ads-pagination.css";
export default {
  name: "PaginationTable.vue",
  components: {
    VueAdsPagination: VueAdsPagination,
    VueAdsPageButton: VueAdsPageButton
  },
  data: function data() {
    return {
      loading: false,
      currentPage: 0
    };
  },
  methods: {
    pageChangeButton: function pageChangeButton(page) {
      this.currentPage = page;
      this.$emit("onChangedPage", page);
    },
    customizeButtonElements: function customizeButtonElements(button) {
      if (button.html.includes("left")) {
        return _objectSpread(_objectSpread({}, button), {}, {
          html: button.html.replace("left", "right")
        });
      }

      if (button.html.includes("right")) {
        return _objectSpread(_objectSpread({}, button), {}, {
          html: button.html.replace("right", "left")
        });
      }

      return button;
    }
  },
  props: {
    totalItems: {
      type: Number,
      required: true
    },
    itemsPerPage: {
      type: Number,
      required: true
    }
  }
};